export const MODE_APPOINTMENT = 'OAR';
export const MODE_CONTACT = 'Contact form';

export const QUESTION_TYPES = {
  MULTISELECT: 'multiselect',
  STRING: 'string',
  TEXT: 'text',
  FILE: 'file',
  SELECT: 'select',
};

export const QUESTION_NAMES = {
  GENDER: 'gender',
  PREFERRED_CLINICIAN: 'preferred_clinician',
  STATE: 'state',
  INSURANCE_CARD_UPLOAD: 'insurance_card_upload',
  SEX: 'sex',
};

export const LENGTH_LIMITS = {
  TEXT_AREA_MAX: 600,
};

export const SUBTEXT_MAP = {
  [QUESTION_NAMES.SEX]: 'For insurance verification',
  [QUESTION_NAMES.STATE]: 'Select the state you live in',
};

export const FAKE_PREFIXES = {
  CLINICIAN: 'fake-clinician',
  OFFICE: 'fake-office',
  CPT_CODE: 'fake-code',
  RESERVATION: 'fake-reservation',
};

export const INSURANCE_CARD_SIDES = {
  FRONT_SIDE: 'FRONT_SIDE',
  BACK_SIDE: 'BACK_SIDE',
};

export const CLIENT_TYPES = {
  client: 'Individual',
  couple: 'Couple',
  contact: 'Other',
};

export const PRESCREENER_CATEGORIES = {
  REASON_FOR_CARE: 'reason for care',
  BILLING_PAYMENT: 'billing & payment',
  ADMINISTRATIVE: 'administrative',
  CLIENT_PREFERENCES: 'client preferences',
};

export const UNSUPPORTED_CATEGORIES = ['demographics'];

export const APPOINTMENT_INFO_COMPLETION_KEYS = {
  CLINICIAN: 'clinician',
  SERVICE: 'cptCode',
  LOCATION: 'office',
  DATE: 'isReserved',
};

export const PRESCREENER_COMPLETION_KEYS = {
  REASON_FOR_CARE: 'hasCompletedReasonForCare',
  BILLING_PAYMENT: 'hasCompletedBillingAndPayment',
  ADMINISTRATIVE: 'hasCompletedAdministrative',
  CLIENT_PREFERENCES: 'hasCompletedClientPreferences',
};

export const VALIDATION_MESSAGES = {
  multiselect: {
    hint: "This can't be blank.",
    default: "This can't be blank. Select all that apply",
  },
  string: "This field can't be blank",
  text: "This field can't be blank",
  select: "This field can't be blank",
  file: 'Please upload the front and back of your insurance card',
  state: "This field can't be blank. Select the state you live in",
};

export const DEFAULT_ATTRS = {
  maxLength: LENGTH_LIMITS.TEXT_AREA_MAX,
  isDirty: false,
};

export const DEFAULT_MAX_LENGTH_BY_TYPE = {
  [QUESTION_TYPES.STRING]: LENGTH_LIMITS.TEXT_AREA_MAX,
  [QUESTION_TYPES.TEXT]: LENGTH_LIMITS.TEXT_AREA_MAX,
};

export const APPOINTMENT_INFO_PREREQUISITE_ORDER = [
  APPOINTMENT_INFO_COMPLETION_KEYS.CLINICIAN,
  APPOINTMENT_INFO_COMPLETION_KEYS.SERVICE,
  APPOINTMENT_INFO_COMPLETION_KEYS.LOCATION,
  APPOINTMENT_INFO_COMPLETION_KEYS.DATE,
];

export const COMPLETION_KEY_TO_ROUTE = {
  [APPOINTMENT_INFO_COMPLETION_KEYS.CLINICIAN]: 'clinician',
  [APPOINTMENT_INFO_COMPLETION_KEYS.SERVICE]: 'service',
  [APPOINTMENT_INFO_COMPLETION_KEYS.LOCATION]: 'location',
  [APPOINTMENT_INFO_COMPLETION_KEYS.DATE]: 'date',
};

export const PRESCREENER_CATEGORY_TO_ROUTE = {
  [PRESCREENER_CATEGORIES.REASON_FOR_CARE]: 'prescreener-reason-for-care',
  [PRESCREENER_CATEGORIES.BILLING_PAYMENT]: 'prescreener-billing-payment',
  [PRESCREENER_CATEGORIES.ADMINISTRATIVE]: 'prescreener-administrative',
  [PRESCREENER_CATEGORIES.CLIENT_PREFERENCES]: 'prescreener-client-preferences',
};

const _categoryRoutes = Object.values(PRESCREENER_CATEGORY_TO_ROUTE);
export const PRESCREENER_CATEGORY_ROUTES = Object.freeze(_categoryRoutes);

const _routeToCategory = Object.entries(PRESCREENER_CATEGORY_TO_ROUTE).reduce(
  (acc, [category, route]) => {
    acc[route] = category;
    return acc;
  },
  {}
);
export const PRESCREENER_ROUTE_TO_CATEGORY = Object.freeze(_routeToCategory);

const _stepIdToCompletionKey = Object.entries(PRESCREENER_CATEGORIES).reduce(
  (acc, [key, categoryName]) => {
    const stepId = `prescreener ${categoryName}`;
    acc[stepId] = PRESCREENER_COMPLETION_KEYS[key];
    return acc;
  },
  {}
);
export const PRESCREENER_STEP_ID_TO_COMPLETION_KEY = Object.freeze(_stepIdToCompletionKey);

const _stepIdToCategoryName = Object.entries(PRESCREENER_CATEGORIES).reduce(
  (acc, [_key, categoryName]) => {
    const stepId = `prescreener ${categoryName}`;
    acc[stepId] = categoryName;
    return acc;
  },
  {}
);
export const PRESCREENER_STEP_ID_TO_CATEGORY_NAME = Object.freeze(_stepIdToCategoryName);

const _resetObject = Object.values(PRESCREENER_COMPLETION_KEYS).reduce((acc, _key) => {
  acc[_key] = false;
  return acc;
}, {});
export const PRESCREENER_RESET_OBJECT = Object.freeze(_resetObject);
